import DownloadIcon from "@mui/icons-material/SaveAlt";
import { Alert, Divider, List, ListItemButton, Snackbar } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import httpRequest from "../../HttpService";
import ImageViewer from "../../orderStatus/components/imageViewer";
import CustomDialog from "../components/dialog/Dialog";
import TextInput from "../components/inputFields/TextInput";
//import ReactPanZoom from 'react-image-pan-zoom-rotate';
import {
  AttachFile,
  Audiotrack,
  Description,
  Image,
  PictureAsPdf,
  Theaters,
} from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import CopyIcon from "@mui/icons-material/FileCopy";
import copy from "copy-to-clipboard";
import { saveAs } from "file-saver";
import moment from "moment";

const dropzoneAccept = {
  "image/jpeg": [],
  "image/png": [],
  "image/bmp": [],
  "image/gif": [],
  "application/pdf": [],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "text/csv": [".csv"],
  "audio/wav": [".wav"],
  "video/mp4": [".mp4"],
  "audio/mp3": [".mp3"],
  "audio/ogg": [".ogg"],
  "audio/m4a": [".m4a"],
};

const FileDropzone = ({ onDrop }) => {
  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({
      accept: dropzoneAccept,
      maxSize: 78643200,
      maxFiles: 1,
      onDrop,
    });
  return (
    <Box
      {...getRootProps()}
      sx={{
        height: 120,
        width: "100%",
        m: "3px",
        border: "1px dashed",
        borderColor: isDragActive ? "primary.main" : "grey.400",
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        cursor: "pointer",
        backgroundColor: isDragActive ? "action.hover" : "background.paper",
      }}
    >
      <input {...getInputProps()} />
      <Typography variant="body2">
        {isDragActive
          ? "Drop the file here…"
          : "Drag a file here, or click to select"}
      </Typography>
      {acceptedFiles.length > 0 && (
        <Typography variant="caption" sx={{ mt: 0.5 }}>
          {acceptedFiles[0].name}
        </Typography>
      )}
    </Box>
  );
};

const WDGallery = (props) => {
  // const [jobId, setJobId] = useState(props.jobId);
  const [selectedPhoto, setSelectedPhoto] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [base64TextString, setBase64TextString] = useState(null);
  const [pictureComment, setPictureComment] = useState("");
  const [isUploadFile, setIsUploadFile] = useState(false);
  const [copiedId, setCopiedId] = useState(null);

  // const [photoList, setPhotoList] = useState(props.photoArray);
  const [photoList, setPhotoList] = useState([]);
  const [fileURL, setFileURL] = useState("");
  const [fileType, setFileType] = useState("");
  const [isPreviewON, setIsPreviewON] = useState(true);

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileEXT, setSelectedFileEXT] = useState(null);

  const [openSnack, setOpenSnack] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState(undefined);
  const [messageType, setMessageType] = React.useState(undefined);

  useEffect(() => {
    try {
      httpRequest.getPhotoURLs(props.jobId).then(async (response) => {
        //console.log(" useEffect getPhotoURLs--" + JSON.stringify(response.data));
        let imageList = response.data.map((value, i) => {
          value.savedTimeUTC = moment(value.savedTimeUTC).format(
            "YY-MM-DD HH:mm",
          );
          value.id = i;
          value.imageType =
            value.url.endsWith("png") ||
            value.url.endsWith("jpg") ||
            value.url.endsWith("bmp")
              ? "image"
              : "file";
          value.fileType =
            value.url.endsWith("png") ||
            value.url.endsWith("jpg") ||
            value.url.endsWith("jpeg") ||
            value.url.endsWith("bmp")
              ? "image"
              : value.url.substring(value.url.lastIndexOf(".") + 1);
          value.fileExt = value.url.substring(value.url.lastIndexOf(".") + 1);
          return value;
        });
        console.log("useEffect imageList--" + JSON.stringify(imageList));
        setPhotoList(imageList);
        if (imageList.length > 0) {
          console.log(" useEffect imageList--" + JSON.stringify(imageList[0]));
          setFileType(imageList[0].fileType);
          setSelectedPhoto(imageList[0]);
          if (
            imageList[0].fileExt === "pdf" ||
            imageList[0].fileExt === "doc" ||
            imageList[0].fileExt === "docx" ||
            imageList[0].fileExt === "xls" ||
            imageList[0].fileExt === "xlsx" ||
            imageList[0].fileExt === "csv"
          ) {
            var file_url = `https://drive.google.com/viewerng/viewer?embedded=true&url=${imageList[0].url}#toolbar=0&scrollbar=0`;
            setFileURL(file_url);
          } else setFileURL(imageList[0].url);
        }
        setIsUploadFile(false);
      });
    } catch (e) {
      console.log("gallery useEffect error:" + e);
    }
  }, [isUploadFile]);

  const renderPreviewIcon = (file, fileUrl) => {
    const type = file.type;
    if (type.startsWith("image/")) return <Image />;
    if (type.startsWith("video/")) return <Theaters />;
    if (type.startsWith("audio/")) return <Audiotrack />;
    switch (type) {
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return <Description />;
      case "application/pdf":
        return <PictureAsPdf />;
      default:
        return <AttachFile />;
    }
  };

  const selectFile = (files) => {
    if (files && files[0]) {
      setIsPreviewON(true);

      let file = files[0];
      let fileExt = file.name.split(".").pop();
      console.log(file.name + "select file type-" + fileExt);
      setSelectedFileEXT(fileExt);
      setSelectedFile(file[0]);
      if (file) {
        const reader = new FileReader();
        reader.onload = _handlerReaderLoaded.bind(this);
        reader.readAsBinaryString(file);
      }
    }
  };

  const _handlerReaderLoaded = (readerEvt) => {
    let binaryString = readerEvt.target.result;
    setBase64TextString(btoa(binaryString));
  };

  const isImage = (ext) => {
    if (ext) {
      return (
        ext === "jpg" ||
        ext === "JPG" ||
        ext === "JPEG" ||
        ext === "jpeg" ||
        ext === "png" ||
        ext === "PNG" ||
        ext === "gif" ||
        ext === "bmp" ||
        ext === "BMP"
      );
    }
  };

  const doUpload = (e) => {
    //e.preventDefault();
    if (isImage(selectedFileEXT)) uploadImage();
    else uploadFile();
  };

  const uploadImage = () => {
    //e.preventDefault();
    //console.log("============binary string:", base64TextString);
    const base64 = base64TextString;
    var BlobPath = "https://directitsqlblob.blob.core.windows.net/images/";
    //var BlobPath = "https://directitsqlblob.blob.core.windows.net/ghy-test/";
    const date = new Date();
    var blobFileName = props.jobId + date.valueOf() + "." + selectedFileEXT;

    httpRequest.doUploadImage(base64, blobFileName).then(function (response) {
      console.log(response.data);
    });
    httpRequest
      .doAttachment(props.jobId, BlobPath + blobFileName, 2, pictureComment)
      .then((body) => {
        console.log("doAttachment uploadPicture-" + JSON.stringify(body.data));
        props.setUploadFileFlag();
        setOpenDialog(true);
        if (selectedFileEXT === "PNG" || selectedFileEXT === "png")
          setFileURL("data:image/png;base64, " + base64TextString);
        if (selectedFileEXT === "BMP" || selectedFileEXT === "bmp")
          setFileURL("data:image/bmp;base64, " + base64TextString);
        if (
          selectedFileEXT === "jpg" ||
          selectedFileEXT === "JPG" ||
          selectedFileEXT === "jpeg"
        )
          setFileURL("data:image/jpeg ;base64, " + base64TextString);
        if (selectedFileEXT === "gif")
          setFileURL("data:image/gif;base64, " + base64TextString);
        setFileType("image");
        setIsUploadFile(true);
      });
  };

  //https://stackoverflow.com/questions/43270793/angular-2-how-to-display-pdf-file
  const uploadFile = () => {
    var BlobPath = "https://directitsqlblob.blob.core.windows.net/order-files/";
    var blobFileName =
      props.jobId + new Date().valueOf() + "." + selectedFileEXT;
    console.log("blobFileName is " + blobFileName);
    console.log("loadFile-- " + base64TextString);
    httpRequest.doUploadFile(base64TextString, blobFileName).then((body) => {
      console.log("doUploadFile", JSON.stringify(body.data));
      httpRequest
        .doAttachment(props.jobId, BlobPath + blobFileName, 2, pictureComment)
        .then((body) => {
          console.log("doAttachment uploadFile-" + JSON.stringify(body.data));
          setOpenDialog(true);
          props.setUploadFileFlag();
          setFileType("file");
          var file_url = `https://drive.google.com/viewerng/viewer?embedded=true&url=${BlobPath}${blobFileName}#toolbar=0&scrollbar=0`;
          console.log("doAttachment file_url-" + file_url);
          setFileURL(file_url);
          setIsUploadFile(true);
        });
    });
  };

  const getFileIcon = (photo) => {
    if (photo.imageType === "image") return <Image fontSize="small" />;
    if (photo.fileExt === "pdf") return <PictureAsPdf fontSize="small" />;
    if (photo.fileExt === "doc" || photo.fileExt === "docx")
      return <Description fontSize="small" />;
    if (["mp3", "wav", "ogg", "m4a"].includes(photo.fileExt))
      return <Audiotrack fontSize="small" />;
    if (photo.fileExt === "mp4") return <Theaters fontSize="small" />;
    return <AttachFile fontSize="small" />;
  };

  const selectPhoto = (photo) => {
    setSelectedPhoto(photo);
    if (["pdf", "doc", "docx", "xls", "xlsx", "csv"].includes(photo.fileExt)) {
      setFileURL(
        `https://drive.google.com/viewerng/viewer?embedded=true&url=${photo.url}#toolbar=0&scrollbar=0`,
      );
    } else {
      setFileURL(photo.url);
    }
    setFileType(photo.fileType);
  };

  const commentChange = (event) => {
    console.log(event.target.name, event.target.value);
    setPictureComment(event.target.value);
  };

  const downloadImage = (url, fileName) => {
    saveAs(url, fileName); // Put your image url here.
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Preview */}
      {fileType === "image" && (
        <Box
          sx={{
            width: "100%",
            height: 280,
            overflow: "hidden",
            position: "relative",
            mb: 1.5,
          }}
        >
          {/* <ReactPanZoom src={fileURL} /> */}
          <ImageViewer src={fileURL} />
        </Box>
      )}
      {(fileType === "pdf" ||
        fileType === "doc" ||
        fileType === "docx" ||
        fileType === "xls" ||
        fileType === "xlsx" ||
        fileType === "gif" ||
        fileType === "csv") && (
        //  src="https://drive.google.com/viewerng/viewer?embedded=true&url=https://directitsqlblob.blob.core.windows.net/order-files/135805831657388729737.pdf#toolbar=0&scrollbar=0"
        <Box sx={{ width: "100%", mb: 1.5 }}>
          <iframe
            src={fileURL}
            height="280px"
            width="100%"
            style={{ display: "block" }}
          ></iframe>
        </Box>
      )}

      {/* File list */}
      {photoList !== null && photoList.length > 0 && (
        <List
          dense
          disablePadding
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            mb: 1.5,
          }}
        >
          {photoList.map((photo, index) => (
            <Box key={photo.id}>
              {index > 0 && <Divider component="li" />}
              <ListItemButton
                selected={selectedPhoto?.id === photo.id}
                onClick={() => selectPhoto(photo)}
                sx={{ py: 0.75, px: 1, gap: 1.5 }}
              >
                <Box
                  sx={{
                    color: "text.secondary",
                    display: "flex",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  {getFileIcon(photo)}
                </Box>
                <Box sx={{ flex: "0 0 130px" }}>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      color: "text.disabled",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      fontSize: "0.6rem",
                      mb: 0.25,
                    }}
                  >
                    Date / Time
                  </Typography>
                  <Typography variant="body2">
                    {photo.savedTimeUTC || (
                      <span style={{ color: "#ccc" }}>—</span>
                    )}
                  </Typography>
                </Box>
                <Box sx={{ flex: "0 0 auto", whiteSpace: "nowrap", pr: 1 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      color: "text.disabled",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      fontSize: "0.6rem",
                      mb: 0.25,
                    }}
                  >
                    Dr #
                  </Typography>
                  <Typography variant="body2">
                    {photo.drNum || <span style={{ color: "#ccc" }}>—</span>}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      color: "text.disabled",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      fontSize: "0.6rem",
                      mb: 0.25,
                    }}
                  >
                    Comment
                  </Typography>
                  <Typography variant="body2" noWrap>
                    {photo.comment || <span style={{ color: "#ccc" }}>—</span>}
                  </Typography>
                </Box>
                <Stack direction="row" spacing={0} sx={{ flexShrink: 0 }}>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (photo.fileType !== "image") {
                        saveAs(
                          photo.url,
                          `${props.jobId}-${photo.savedTimeUTC}`,
                        );
                      } else {
                        downloadImage(
                          photo.url,
                          photo.url.substring(photo.url.lastIndexOf("/") + 1),
                        );
                      }
                    }}
                  >
                    <DownloadIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    color={copiedId === photo.id ? "success" : "primary"}
                    title={copiedId === photo.id ? "Copied!" : "Copy URL"}
                    onClick={(e) => {
                      e.stopPropagation();
                      copy(photo.url);
                      setCopiedId(photo.id);
                      setTimeout(() => setCopiedId(null), 2000);
                    }}
                  >
                    {copiedId === photo.id ? (
                      <CheckIcon fontSize="small" />
                    ) : (
                      <CopyIcon fontSize="small" />
                    )}
                  </IconButton>
                </Stack>
              </ListItemButton>
            </Box>
          ))}
        </List>
      )}

      {/* Upload area */}
      <FileDropzone
        onDrop={(accepted, rejected) => {
          if (rejected && rejected.length > 0) {
            const r = rejected[0];
            const tooBig = r.errors?.some((e) => e.code === "file-too-large");
            setMessageInfo(
              tooBig
                ? "Reduce file to 4.5Meg or lower"
                : r.errors?.[0]?.message || "File rejected",
            );
            setMessageType("error");
            setOpenSnack(true);
            return;
          }
          if (accepted && accepted.length > 0) {
            selectFile(accepted);
            const file = accepted[0];
            if (file.type.startsWith("image/")) {
              const reader = new FileReader();
              reader.onload = (e) => {
                setFileURL(e.target.result);
                setFileType("image");
              };
              reader.readAsDataURL(file);
            } else {
              setFileURL("");
              setFileType("");
            }
          }
        }}
      />
      <Stack direction="row" spacing={1} alignItems="flex-end" sx={{ mt: 1 }}>
        <Box sx={{ flex: 1, textAlign: "center" }}>
          <TextInput
            className="labeledField"
            label="Comments"
            type="text"
            inputType="text"
            size="small"
            name="comment"
            labelSize={0}
            multiline
            minRows={1}
            value={pictureComment}
            onChange={commentChange}
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          onClick={doUpload}
          sx={{ mb: "1px" }}
        >
          Submit
        </Button>
      </Stack>
      <CustomDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        hasCloseBtn={false}
        dialogMessage={"Selected file was uploaded!"}
        dialogTitle="Notification"
        dialogAction={() => {
          setOpenDialog(false);
          setIsPreviewON(false);
        }}
      />
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={() => {
          setOpenSnack(false);
        }}
      >
        <Alert
          onClose={() => {
            setOpenSnack(false);
          }}
          severity={messageType}
          sx={{ width: "100%" }}
        >
          {messageInfo}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default WDGallery;

//https://codesandbox.io/s/rp01w?file=/src/App.tsx:1156-1285
//https://stackoverflow.com/questions/66158526/programmatically-preselecting-a-row-in-material-uis-data-gridreact
//https://stackoverflow.com/questions/17784037/how-to-display-pdf-file-in-html
//https://mui.com/material-ui/react-snackbar/
//https://javascript.plainenglish.io/material-ui-snack-bar-customization-1c0261bdc419
